import { Heading, Spread, Surface, Text, VStack } from '@/components/Atoms'
import { FuzeLogo } from '@/components/Logo'
import useLogout from '@/hooks/useLogout'
import { SUPPORT_EMAIL } from '@repo/constants'
import { Button } from '@repo/ui/components'
import { cn } from '@repo/ui/lib/utils'
import { createFileRoute } from '@tanstack/react-router'
import { MailIcon, UserRoundIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'

export const Route = createFileRoute('/_auth/unverified/')({
  component: Unverified,
})

const Container = (props: { children: React.ReactNode; className?: string }) => (
  <div className={cn('container mx-auto xl:max-w-7xl 2xl:max-w-7xl', props.className)}>
    {props.children}
  </div>
)

function Unverified() {
  const { t } = useTranslation('login')
  const { logout } = useLogout()

  const handleLogout = async () => await logout()

  return (
    <>
      <Surface
        className="bg-background-level-1/90 fixed top-0 z-50 flex h-16 w-full items-center border-b backdrop-blur-lg"
        border={false}
      >
        <Container>
          <Spread align="center">
            <FuzeLogo type="full" className="h-6 w-fit pl-2" />
            <Button variant="ghost" onClick={handleLogout}>
              <UserRoundIcon /> {t('Log Out')}
            </Button>
          </Spread>
        </Container>
      </Surface>

      <div className="bg-background-level-2 relative h-[100svh] w-full overflow-clip">
        <Container className="relative z-10 h-full py-16">
          <div className="relative grid h-full grid-cols-2 gap-16">
            <FuzeLogo
              type="broken"
              className="absolute -bottom-1/4 -right-full h-[120svh] opacity-5"
            />

            <VStack gap="xl" className="z-10 mt-5 h-full justify-center">
              <VStack gap="sm">
                <Heading level={1} className="text-7xl tracking-tighter">
                  {t('Oh no!')}
                </Heading>
                <Heading level={1} className="text-pretty text-4xl tracking-tighter">
                  {t('account.unverified.title')} 😕
                </Heading>
              </VStack>

              <Text className="text-pretty text-2xl font-normal leading-snug">
                {t('account.unverified.description')}
              </Text>

              <Button variant="secondary" size="lg" className="mt-4" asChild>
                <a href={`mailto:${SUPPORT_EMAIL}`} target="_blank" rel="noreferrer">
                  <MailIcon />
                  {t('Contact support')}
                </a>
              </Button>
            </VStack>
          </div>
        </Container>
      </div>
    </>
  )
}
